import { useEffect, useState } from "react";
import { Box3, Vector3 } from "three";

function Dimension() {
  useEffect(() => {
    let viewer = document.getElementById("modelViewer");
    viewer.addEventListener("init-model-load", getDimensions.bind(this));
    document.addEventListener("glb-loaded", getDimensions.bind(this));
  }, []);

  const [x, setX] = useState(0);
  const [y, setY] = useState(0);
  const [z, setZ] = useState(0);

  const getDimensions = () => {
    const modelViewer = document.getElementById("modelViewer");
    const scene = modelViewer?.scene();

    if (
      !scene.modelContainer ||
      !scene.modelContainer.children ||
      scene.modelContainer.children.length == 0
    )
      return;

    let boundingBox = new Box3().setFromObject(
      scene.modelContainer.children[0]
    );
    const center = new Vector3();
    const size = new Vector3();
    boundingBox.getCenter(center);
    boundingBox.getSize(size);

    let x = (size.x * 100).toFixed();
    let y = (size.y * 100).toFixed();
    let z = (size.z * 100).toFixed();
    setX(x);
    setY(y);
    setZ(z);

    //setDimension({ xWidth: size.x, yHeight: size.y, zDepth: size.z });

    return size;
  };

  return (
    <div className="column">
      <div className="row">
        <div className="dimText">X : </div>
        <span>{x} cm</span>
      </div>

      <div className="row">
        <div className="dimText">Y : </div>
        <span>{y} cm</span>
      </div>

      <div className="row">
        <div className="dimText">Z : </div>
        <span>{z} cm</span>
      </div>
    </div>
  );
}
export default Dimension;
